import { useState, useEffect } from 'react';
import { getEnvConfig } from '../../redux/env/envActions';

const useFetchEnv = () => {
  const [value, setValue] = useState('');

  const getResult = async () => {
    const result = await getEnvConfig();

    setValue(result['LIVE_MODE_FEATURE_ENABLED']);
  };

  useEffect(() => {
    getResult();
  }, []);

  return [value, setValue];
};

export default useFetchEnv;
